import { render } from "./AsideTools.vue?vue&type=template&id=2efe76ec"
import script from "./AsideTools.vue?vue&type=script&lang=js"
export * from "./AsideTools.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__